// @__NO_SIDE_EFFECTS__
function r(n) {
  let e;
  return () => (e === void 0 && (e = n()), e);
}
export {
  r as memo
};
